module.exports = __webpack_public_path__ + "static/media/AngelsOfAether_Race_06.97deb120.jpg";